var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout"},[_c('checkout-flow',{attrs:{"offer":_vm.$route.query.offer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }